<template>
  <div class="container">
    <div v-wechat-title="($route.meta.title = productTitle)"></div>
    <div class="swiperBox">
      <van-swipe
        style="width: 100%; height: 100%"
        :autoplay="autoplay"
        :show-indicators="indicatorDots"
        indicator-color="white"
        @change="changeSwipe"
      >
        <van-swipe-item
          v-for="(item, index) in productInfo.ImgList"
          :key="index"
        >
          <div class="hasVideo" v-if="index == 0 && videoSrc">
            <video
              :src="videoSrc"
              controls
              id="myVideo"
              class="myVideo"
              @play="bindplay"
              @pause="bindpause"
              @ended="bindended"
              v-show="videoPlay"
            />
            <img :src="item.Path" class="slide-image" v-show="!videoPlay" />
            <img
              src="../../../static/images/index/play.png"
              class="playIcon"
              v-show="!videoPlay"
              @click="suspend"
            />
          </div>
          <img :src="item.Path" class="slide-image" v-else />
        </van-swipe-item>
      </van-swipe>
    </div>
    <div class="productNameBox">{{ productInfo.GoodsName }}</div>
    <!-- 店铺 -->
    <div class="storeBox" @click="toIndex(productInfo.MemberId)">
      <div class="storeLeftBox">
        <van-image :src="productInfo.Photo" class="storeImg" fit="contain" />
        <div class="storeNameBox">
          <div class="storeName van-ellipsis">{{ productInfo.Headline }}</div>
          <div class="address van-ellipsis">{{ productInfo.Region }}</div>
        </div>
      </div>
      <div class="storeRightBox">
        <div style="margin-right: 16rpx">进入展厅</div>
        <van-icon name="arrow" />
      </div>
    </div>
    <!-- 参数 -->
    <div class="parameterBox" v-if="productInfo.List">
      <div class="parameterTitle">主要参数</div>
      <div class="parameterInnerBox">
        <div
          class="parameterItem"
          v-for="(item, index) in productInfo.List"
          :key="index"
        >
          {{ item.AttrName }}：{{ item.AttrValues[0].AttrValueName }}
        </div>
      </div>
    </div>
    <!-- 富文本 -->
    <div class="descriptionTitle">产品详情</div>
    <div class="descriptionBox" v-html="content"></div>

    <!--分享-->
    <div class="shareLayer" v-show="showLayer" @click="showLayer = false">
      <img src="../../../static/images/index/layer.png" />
    </div>

    <!-- 海报 -->
    <div class="code-flex" v-if="codeShow">
      <div class="code-box" ref="imageDom">
        <div class="codeTop">
          <img :src="base64ImgData.imgpro" alt class="pro" />
          <div class="name van-ellipsis">{{ productInfo.GoodsName }}</div>
        </div>
        <div class="codeMid">
          <div id="qrcode" ref="canvas"></div>
          <p>长按我，识别了解我</p>
        </div>
        <div
          class="codeBtm van-clearfix"
          v-if="productInfo.BusinessContactModel"
        >
          <div class="left">
            <div class="van-ellipsis">{{ productInfo.Headline }}</div>
            <div class="name">
              {{ productInfo.BusinessContactModel.ContactName }}
              <span>{{ productInfo.BusinessContactModel.Duty }}</span>
            </div>
            <div class="mobile">
              {{ productInfo.BusinessContactModel.Mobile }}
            </div>
          </div>
          <div class="right">
            <img :src="base64ImgData.weixinqrcode" alt />
            <div>长按我加微信</div>
          </div>
        </div>
      </div>
      <img :src="imgcode" v-if="imgcode" class="saveImg" />
      <div class="forwardBtn">长按图片保存</div>
    </div>

    <!--遮罩层-->
    <van-overlay
      :show="showLayer || codeShow"
      @click="(showLayer = false), (codeShow = false)"
    ></van-overlay>

    <!-- 底部 -->
    <div class="footerBox">
      <div class="footerInnerBox">
        <div class="footerLeft">
          <a class="footerItem" :href="'tel:' + productInfo.Mobile">
            <img
              src="../../../static/images/productDetail/call.png"
              class="iconImg"
            />
            <div style="color: #666">打电话</div>
          </a>
          <div class="footerItem" @click="shareHandle">
            <img
              src="../../../static/images/productDetail/share.png"
              class="iconImg"
            />
            <div style="font-size: 22rpx">分享</div>
          </div>
          <div class="footerItem" @click="posterHandle">
            <img
              src="../../../static/images/productDetail/poster.png"
              class="iconImg"
            />
            <div>生成海报</div>
          </div>
          <div
            class="footerItem chatButton"
            @click="chatHandle(productInfo.Headline)"
          >
            聊一聊
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import QRCode from "qrcodejs2"; //生成二维码
import html2canvas from "html2canvas"; //把h5网页保存为图片
import { getShareData } from "@/utils/share";
import { productDetail, converPhotoBase64 } from "@/api/product";
import { Swipe, SwipeItem, Icon, Overlay, Image, Toast } from "vant";
export default {
  name: "productDetail",
  components: {
    "van-swipe": Swipe,
    "van-swipe-item": SwipeItem,
    "van-icon": Icon,
    "van-overlay": Overlay,
    "van-image": Image,
  },
  data() {
    return {
      showLayer: false, //右上角分享
      codeShow: false, //海报
      productInfo: "",
      content: "", //富文本
      productTitle: "", //title
      codeUrl: process.env.VUE_APP_BASE_HREF + "/productDetail?id=", //二维码链接
      imgcode: "", //生成的二维码图片
      base64ImgData: {
        weixinqrcode: "", //需转换格式的图片
        imgpro: "",
      },
      autoplay: 3000,
      indicatorDots: true,
      videoPlay: false,
      videoSrc: "",
    };
  },
  methods: {
    //聊一聊
    chatHandle(name) {
      Toast("暂无该功能！");
      // this.$router.push({
      //   path: "/chat",
      //   query: { cid: "C2C" + this.$route.query.mid, name: name },
      // });
    },

    //播放
    bindplay: function () {
      this.videoPlay = true;
      this.indicatorDots = false;
      this.autoplay = "";
    },

    //暂停
    bindpause: function () {
      this.videoPlay = true;
      this.indicatorDots = false;
      this.autoplay = 3000;
    },

    //结束
    bindended: function () {
      this.videoPlay = false;
      this.indicatorDots = true;
      this.autoplay = 3000;
    },

    //播放
    suspend() {
      var video = document.getElementById("myVideo");
      if (video.paused) {
        this.videoPlay = true;
        this.indicatorDots = false;
        this.autoplay = "";
        video.play();
      }
    },

    //轮播图
    changeSwipe() {
      this.videoPlay = false;
      this.indicatorDots = true;
      this.autoplay = 3000;
    },

    //获取产品详情
    getProductDetail() {
      var that = this;
      var data = {
        GoodId: that.$route.query.id,
        BusinessMemberId: 0,
      };
      productDetail(data).then((res) => {
        if (res.Data.ImgList) {
          var imglist = [];
          res.Data.ImgList.forEach((item, index) => {
            if (index == 0 && item.Type == 1) {
              that.videoSrc = item.Path;
            } else {
              imglist.push(item);
            }
          });
          res.Data.ImgList = imglist;
        }
        that.productInfo = res.Data;
        that.content = res.Data.MobileContent;
        that.content = that.content.replace(
          /<img/g,
          "<img style='width:100% !important;height:auto !important;'"
        );
        that.content = that.content.replace(
          /<table/g,
          "<table style='width:100% !important;height:auto !important;'"
        );
        that.content = that.content.replace(
          /<p/g,
          "<p style='text-indent:0px !important;'"
        );
        that.content = that.content.replace(
          /<ul/g,
          "<ul style='width:100% !important;'"
        );
        that.content = that.Common.escape2Html(that.content);
        that.productTitle = res.Data.GoodsName;
        localStorage.setItem("productTitle", res.Data.GoodsName);
        that.codeUrl =
          process.env.VUE_APP_BASE_HREF +
          "/productDetail?id=" +
          res.Data.GoodsId;
        getShareData(
          window.location.href,
          res.Data.GoodsName,
          res.Data.GoodsName,
          res.Data.Thumbnail
        );
      });
    },

    //进入展厅
    toIndex(id) {
      this.$router.push({
        path: "/storeShow",
        query: { mid: id },
      });
    },

    //分享好友，朋友圈（需判断是否是微信端）
    shareHandle() {
      this.showLayer = true;
    },

    //生成海报
    posterHandle() {
      this.codeShow = true;
      this.$nextTick(() => {
        this.qrcode();
      });
    },

    //整张海报图片生成
    generatePosterImage() {
      var that = this;
      that.show = false;
      that.codeShow = true;
      html2canvas(that.$refs.imageDom, {
        backgroundColor: "transparent", //设置透明背景
        useCORS: true, // 【重要】开启跨域配置
        allowTaint: true, //允许跨域图片
        taintTest: false, //是否在渲染前测试图片
      }).then((canvas) => {
        let imgUrl = canvas.toDataURL("image/png");
        that.imgcode = imgUrl;
      });
    },

    // 生成二维码
    qrcode() {
      var that = this;
      let qrcode = new QRCode("qrcode", {
        width: 58, // 宽度
        height: 58, // 高度
        background: "#ffffff", // 背景色
        foreground: "#000000", // 前景色
        text: that.codeUrl, // 二维码内容
        render: "canvas", // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
      });

      var imgData = [
        {
          name: "weixinqrcode",
          value:
            that.productInfo.BusinessContactModel &&
            that.productInfo.BusinessContactModel.WeiXinQRCode
              ? that.productInfo.BusinessContactModel.WeiXinQRCode
              : null,
        },
        {
          name: "imgpro",
          value:
            that.productInfo.ImgList.length > 0
              ? that.productInfo.ImgList[0]
              : null,
        },
      ];
      that.pictureFormat(imgData);
    },

    //转换图片格式
    async pictureFormat(imgData) {
      for (var i in imgData) {
        let newName = imgData[i].name;
        if (imgData[i].value) {
          var data = {
            Photo: imgData[i].value.Path,
          };
          await converPhotoBase64(data).then((res) => {
            this.base64ImgData[newName] = res.Data;
            console.log(newName);
          });
        }
      }
      this.generatePosterImage();
    },
  },
  mounted() {
    this.getProductDetail();
  },
};
</script>
<style scoped src="../../../static/css/productDetail.css"></style>

